import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Giriş başarılı");
      nav(u.role === "admin" ? "/adc" : "/panel/satin-al");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Giriş başarısız");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-panel-bg text-panel-text grid place-items-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><Logo size="lg" /></Link>
        <div className="card p-7">
          <h1 className="font-head text-2xl font-bold">Giriş Yap</h1>
          <p className="text-sm text-panel-secondary mt-1">Hesabına giriş yaparak numara almaya başla.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium">E-posta</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
                className="pinput w-full rounded-xl h-12 px-4 mt-1.5 outline-none focus:border-brand-500" placeholder="ornek@mail.com" />
            </div>
            <div>
              <label className="text-sm font-medium">Şifre</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
                className="pinput w-full rounded-xl h-12 px-4 mt-1.5 outline-none focus:border-brand-500" placeholder="••••••••" />
            </div>
            <button disabled={busy} data-testid="login-submit" className="btn-blue w-full rounded-xl h-12 font-semibold">
              {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </form>
          <p className="text-sm text-panel-secondary mt-5 text-center">
            Hesabın yok mu? <Link to="/kayit" className="text-brand-500 font-semibold">Üye Ol</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
